<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3 class="card-title">Daftar Unit Kerja</h3>
            </div>  
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card" v-if="$gate.isAdmin1()">
              <div class="card-header">
                <!--<button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      Tambah Unit Kerja
                  </button>-->
                <div class="card-tools">
                  <input type="text" v-model="searchTerm"  placeholder="Cari">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                        <th role='button' v-on:click="sortRecords('nama')">Nama Unit Kerja</th>
                        <th role='button' v-on:click="sortRecords('tingkat')">Tingkat</th>
                        <th role='button' v-on:click="sortRecords('tanggal_kunci')">Tanggal Penguncian</th>
                        <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="(unit_kerja, index) in unit_kerjas.data" :key="index">
                        <td class="text-capitalize">{{unit_kerja.nama}}</td>
                      <td>{{unit_kerja.tingkat}}</td>
                       <td>{{unit_kerja.tanggal_kunci}}</td>
                      <td>
                        <a href="#" @click="editModal(unit_kerja)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                    <div class="row">
                        <div class="col-6" style="margin-top:10px;">
                                Menampilkan <select v-model="pageShow" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Baris
                        </div>

                        <div class="col-6">
                            <pagination style="float:right;" :data="unit_kerjas" @pagination-change-page="getResults"></pagination>
                        </div>
                    </div>    
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <div v-if="!$gate.isAdmin1()">
            <not-found></not-found>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Unit Kerja</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Unit Kerja</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateUnitKerja() : createUnitKerja()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Nama Unit Kerja</label>
                            <input v-model="form.nama" type="text" name="nama"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('nama') }">
                            <has-error :form="form" field="nama"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Tingkat (1=Induk, 2=UPTD/Bidang)</label>
                            <select v-model="form.tingkat" class="form-control" :class="{ 'is-invalid': form.errors.has('tingkat') }">
                                <option default value="">Pilih salah satu</option>
                                <option>1</option>
                                <option>2</option>
                            </select>
                            <has-error :form="form" field="tingkat"></has-error>
                        </div>                    
                        <div class="form-group">
                            <label>Tanggal Penguncian</label>
                            <datepicker v-model="form.tanggal_kunci" :disabledDates="disabledAkhir" :format="format" name="tanggal_kunci" class="form-controlx" :class="{ 'is-invalid': form.errors.has('tanggal_kunci') }"></datepicker>
                            <has-error :form="form" field="tanggal_kunci"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

    export default {
        components: {
            Datepicker
        },
        data () {
            return {
                editmode: false,
                searchTerm:'',
                unit_kerjas : {},
                format: 'yyyy-MM-dd',
                disabledAkhir: {
                    dates:[
                        //new Date(2022, 0, 1)
                    ],
                    ranges: [{ // Disable dates in given ranges (exclusive).
                        from: new Date(),
                        to: new Date(2100, 11, 31)
                    }]
                },
                form: new Form({
                    id : '',      
                    nama: '',
                    tingkat: '',
                    tanggal_kunci:''
                }),
                sortIndex: 'nama',
                sortDirection: 'asc',
                pageShow:10,
            }
        },
        methods: {  
            sortRecords (index) {
               
                this.sortIndex = index;
                if(this.sortDirection == 'asc'){
                   this.sortDirection = 'desc';
                }else if(this.sortDirection == 'desc'){
                   this.sortDirection = 'asc';
                }else{
                   this.sortDirection = 'asc';
                }
                
                this.$Progress.start();
                  
                axios.get('/api/unit_kerja?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow).then(({ data }) => (this.unit_kerjas = data.data));

                this.$Progress.finish();
            },    
            changePageRange(){
                //alert(this.pageShow);
                this.$Progress.start();
                  
                  axios.get('/api/unit_kerja?sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow).then(({ data }) => (this.unit_kerjas = data.data));

                  this.$Progress.finish();
            },      
            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('/api/unit_kerja?page=' + page + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow).then(({ data }) => (this.unit_kerjas = data.data));

                  this.$Progress.finish();
            },
            updateUnitKerja(){
                this.$Progress.start();
                this.form.put('/api/unit_kerja/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadUnitKerjas();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },
            editModal(unit_kerja){
                this.editmode = true;
                this.form.reset();
                $('#addNew').modal('show');
                this.form.fill(unit_kerja);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },

            loadUnitKerjas(){
                let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;
                if(this.$gate.isAdmin1()){
                    axios.get("/api/unit_kerja?search=" + param + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.pageShow).then(({ data }) => (this.unit_kerjas = data.data));
                }
            },
            createUnitKerja(){

                this.form.post('/api/unit_kerja')
                .then((response)=>{
                    $('#addNew').modal('hide');

                    Toast.fire({
                            icon: 'success',
                            title: response.data.message
                    });

                    this.$Progress.finish();
                    this.loadUnitKerjas();
                })
                .catch(()=>{
                    Toast.fire({
                        icon: 'error',
                        title: 'Some error occured! Please try again'
                    });
                })
            }

        },
        created() {

            this.$Progress.start();
            this.loadUnitKerjas();
            this.$Progress.finish();
        },
         mounted() {
            //this.loadUnitKerjas();
            //console.log('Component mounted.');
            
            //console.log(this.rows);
        },
        watch: {
            searchTerm: function() {
                this.loadUnitKerjas();
            }
        }
    }
</script>